import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import moment from "moment"
import { EducationType } from "../../../../../Schemas/ResumeSchemas"
import { Delete, Edit } from "@mui/icons-material"
import { useEffect, useState } from "react"
import { ModifyEducationModal } from "../Edit/Education/ModifyEducationModal"

interface IProps extends EducationType {
    index: number
    readOnly?: boolean;
    handleEdit?: (edu: EducationType, idx: number) => void;
    handleDelete?: (idx: number) => void;
}   

export const ViewEducation = ({ school, title, start_date, end_date, major, readOnly = false, handleDelete, handleEdit, index}:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    //TODO: move this into a hook
    const [open, setOpen] = useState(false);
    const [deleteClicks, setDeleteClicks] = useState(1);
    /* ******************** Functions ******************** */
    const editClicked = () => {
        setOpen(true);
    }
    const deleteClicked = () => {
        if (deleteClicks === 2) {
            handleDelete!(index);
        } else {
            setDeleteClicks(2);
            setTimeout(() => {
                setDeleteClicks(0);
            }, 7000)
        }
    }
    const handleChange = (data: EducationType) => {
        handleEdit!(data, index);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={"flex"} flexDirection={"row"}>
                <Grid display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-medium' >{school ?? "N/A"}</Typography>
                    <Typography color={'black.200'} variant='body-medium'>{`${title}${end_date ? ' - ' + moment(end_date).format('YYYY') :''}`}</Typography>
                </Grid>
                {
                    !readOnly && 
                    <Grid display={"flex"} flexDirection={"row"} flex={1} justifyContent={'flex-end'}>
                        <IconButton size="medium" color="primary" onClick={editClicked}>
                            <Edit fontSize="small"/>
                        </IconButton>
                        <Tooltip open={deleteClicks == 2} title='Click again to confirm delete' placement="right" arrow>
                            <IconButton size="medium" color={deleteClicks == 2 ? "error" : "primary"} onClick={deleteClicked}>
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                }
            </Grid>
            <Divider sx={{ marginBottom: 1}}/>
            <ModifyEducationModal 
                {...{
                    open,
                    setOpen,
                    handleChange,
                    defaultValues: {
                        title,
                        major,
                        school,
                        end_date,
                        start_date
                    },
                    type: 'Edit'
                }}
            />
        </>
    )
}